/*eslint-disable */
var $ = window.jQuery = require('jquery');

import Router from 'vue-router'
import Vue from 'vue'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  //  const router {
  mode: 'history',
  canReuse: false,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
      path: '*',
      redirectTo: '/'
    },
    {
      path: '/',
      name: 'home',
      component: () => import( /* webpackChunkName: "home" */ './view/public/home/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega',
          next();
      }
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      component: () => import( /* webpackChunkName: "testimonials" */ './view/public/testimonials/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Testimonials'
        next();
      }
    },
    {
      path: '/media/',
      name: 'media',
      component: () => import( /* webpackChunkName: "media" */ './view/public/media/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Media'
        next();
      }
    },
    {
      path: '/about-us/',
      name: 'AboutUs',
      component: () => import( /* webpackChunkName: "AboutUs" */ './view/public/about-us/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - About Us'
        next();
      }
    },    
    {
      path: '/user/agreement/',
      name: 'userAgreement',
      component: () => import( /* webpackChunkName: "userAgreement" */ './view/public/user-agreement/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - User Agreement',
        next();
      }
    },
    {
      path: '/contact-us/',
      name: 'ContactUs',
      component: () => import( /* webpackChunkName: "ContactUs" */ './view/public/contact-us/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Contact Us'
        next();
      }
    },
    {
      path: '/help/',
      name: 'help',
      component: () => import( /* webpackChunkName: "help" */ './view/public/help-support-form/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Help'
        next();
      }
    },
    {
      path: '/under/maintenance/',
      name: 'underMaintenance',
      component: () => import( /* webpackChunkName: "underMaintenance" */ './view/public/under-maintenance-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Under Maintenance',
        next();
      }
    },
    {
      path: '/media/details/:mediaId',
      name: 'mediaDetails',
      component: () => import( /* webpackChunkName: "mediaDetails" */ './view/public/media-details/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Media Details'
        next();
      }
    },
    {
      path: '/course/deatils/:category/:slug/',
      name: 'publicCourseDetails',
      component: () => import( /* webpackChunkName: "publicCourseDetails" */ './view/public/course-info-by-slug/index.vue'),
    },
    {
      path: '/privacy-policy/',
      name: 'PrivacyPolicy',
      component: () => import( /* webpackChunkName: "courseDetail" */ './view/public/privacy-policy/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Privacy Policy'
        next();
      }
    },
    {
      path: '/terms-of-condition/',
      name: 'termsOfCondition',
      component: () => import( /* webpackChunkName: "courseDetail" */ './view/public/terms-of-condition/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Terms Of Condition'
        next();
      }
    },
    {
      path: '/course/:slug/',
      name: 'courseCategory',
      component: () => import( /* webpackChunkName: "courseCategory" */ './view/public/courseCategory/index.vue'),
    },
    {
      path: '/course/:category/:slug/',
      name: 'coursedescription',
      component: () => import( /* webpackChunkName: "publicCourseDescription" */ './view/public/publicCourseDescription/index.vue'),
    },
    {
      path: '/all-categories/',
      name: 'allCategoriesPage',
      component: () => import( /* webpackChunkName: "allCategoriesPage" */ './view/public/allCategoriesPage/index.vue'),
      meta: {
        guest: true
      },
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - All Categories'
        next();
      }
    }, 
    {
      path: '/login/',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ './view/authentication/login/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Login'
        next();
      }
    },
    {
      path: '/signup/',
      name: 'signup',
      component: () => import( /* webpackChunkName: "register" */ './view/authentication/register/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Signup'
        next();
      }
    },
    {
      path: '/account/reset-password/',
      name: 'forgotPassword',
      component: () => import( /* webpackChunkName: "forgotPassword" */ './view/authentication/forgot-password/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Password Reset'
        next();
      }
    },
    {
      path: '/account/reset-password/:reset_key',
      name: 'passwordReset',
      component: () => import( /* webpackChunkName: "passwordChanged" */ './view/authentication/password-reset/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Password Reset'
        next();
      }
    },
    {
      path: '/account/verify/:id',
      name: 'userVerified',
      component: () => import( /*webpackChunkName: "userVerified" */ './view/authentication/user-verify/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - User Verify'
        next();
      }
    },
    {
      path: '/dashboard',
      component: () => import( /* webpackChunkName: "userDashboard" */ './view/private/user-dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
      children: [
        {
          path: '/profile/',
          name: 'profile',
          component: () => import( /* webpackChunkName: "userProfile" */ './view/private/user-profile/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('EnrolledCourseByNumber').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {});
            store.dispatch('getAssignmentByNumber').then((res) => {
              $('.httploader').hide()
            })
            store.dispatch('getProfile').then((res) => {
              $('.httploader').hide()
            })
            store.dispatch('getUserAttemptQuizHistoriesList').then((res) => {
            $('.httploader').hide()
            })
            store.dispatch('getContestPointsObtainedFun')
            document.title = 'Oddvega - Profile'
            next();
          }
        },
        {
          path: '/update-profile/',
          name: 'update-profile',
          component: () => import( /* webpackChunkName: "updateUserProfile" */ './view/private/updateUserProfile/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Update Profile'
            next();
          }
        },
        {
          path: '/update-profile/:quizError',
          name: 'update-profile-edit',
          component: () => import( /* webpackChunkName: "updateUserProfile" */ './view/private/updateUserProfile/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Update Profile'
            next();
          }
        },
        {
          path: '/assignment/',
          name: 'assignment',
          component: () => import( /* webpackChunkName: "assignement" */ './view/private/assignment/index.vue'),
          beforeEnter: (to, from, next) => {
            // Get Assignment
            store.dispatch('getAssignmentActn').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {

            })

            document.title = 'Oddvega - Assignment'
            next();
          }
        },
        {
          path: '/courses/',
          name: 'usercourses',
          component: () => import( /* webpackChunkName: "courseList" */ './view/private/course-list/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getProfile').then((res) => {
              store.dispatch('getCategoryListActn').then((res) => {
              store.dispatch('getcourselist')
              .then((res) => {
                $('.httploader').hide()
              })
              });
            }).catch((err) => {});
            document.title = 'Oddvega - Courses'
            next();
          }
        },
        {
          path: '/courses/category/:id',
          name: 'usercourses-category',
          component: () => import( /* webpackChunkName: "coursesBycategory" */ './view/private/coursesBycategory/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getCategoryListActn').then((res) => {
            });
            store.dispatch('getProfile').then((res) => {
              $('.httploader').hide()
            })
            document.title = 'Oddvega - Courses'
            next();
          }
        },
        {
          path: '/courses/:courseid',
          name: 'coursesdescription',
          component: () => import( /* webpackChunkName: "coursesdescription" */ './view/private/coursedetail/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            // store.dispatch('getSingleCourseDetail', {
            //   courseid: to.params.courseid
            // }).then((res) => {
            //   // console.log(error.status, 'Course Details Data')
            // })
            document.title = 'Oddvega - Course'
            next();
          }
        },
        {
          path: '/interview/courses/:courseid',
          name: 'interViewCourseDetails',
          component: () => import( /* webpackChunkName: "interViewCourseDetails" */ './view/private/interview-course-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
              // store.dispatch('getInterviewCourseDetails', {
              //   id: to.params.courseid
              // }).then((res) => {
              // })
            document.title = 'Oddvega - Course'
            next();
          }
        },

        {
          path: '/courses/:courseid/quiz/:quizId',
          name: 'coursesquiz',
          component: () => import( /* webpackChunkName: "courseQuiz" */ './view/private/coursequiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Course Quiz'
            next();
          }
        },

        {
          path: '/favourites/',
          name: 'myFavourites',
          component: () => import( /* webpackChunkName: "myFavourites" */ './view/private/mycourse/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getCategoryListActn').then((res) => {
            });
            store.dispatch('getEnrolledCoursesActn').then((res) => {
              $('.httploader').hide()
            });
            document.title = 'Oddvega - Favourites'
            next();
          }
        },
        {
          path: '/userquizes/history/:courseId',
          name: 'quizHistory',
          component: () => import( /* webpackChunkName: "userQuiz" */ './view/private/userquiz/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Quiz History'
            next();
          }
        },
        {
          path: '/category/:id',
          name: 'courseByCategory',
          component: () => import( /* webpackChunkName: "categoryProject" */ './view/private/categoryproject/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('CourseByCategoryAction', {
              id: to.params.id
            }).then((res) => {

            })
            document.title = 'Oddvega - Category'
            next();
          },
          beforeRouteUpdate: (to, from, next) => {

          }
        },

        {
          path: '/assignment/:id',
          name: 'assignmentBrief',
          component: () => import( /* webpackChunkName: "assignmentBrief" */ './view/private/assignmentbrief/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getSignleAssignmentActn', {
              id: to.params.id
            }).then((res) => {
              $('.httploader').hide()
            }).catch((err) => {

            })
            document.title = 'Oddvega - Assignment'
            next();
          }
        },
        {
          path: '/upload-solution/',
          name: 'uploadSolution',
          component: () => import( /* webpackChunkName: "uploadSolution" */ './view/private/uploadsolution/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Upload Solution'
            next();
          }
        },
        {
          path: '/courses/search/result/:searchkeyword/',
          name: 'searchResults',
          component: () => import( /* webpackChunkName: "searchResults" */ './view/private/searchresult/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Result'
            next();
          }
        },
        {
          path: '/payment/',
          name: 'paypalPayment',
          component: () => import( /* webpackChunkName: "paypalPayment" */ './view/private/paypalPayment/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Payment'
            next();
          }
        },
        {
          path: '/payment/confirm/',
          name: 'paymentConfirmation',
          component: () => import( /* webpackChunkName: "paymentConfirmation" */ './view/private/payment-confirmation/index.vue'),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Payment Confirmation'
            next();
          }
        },
        {
          path: '/payment/history/',
          name: 'paymentHistory',
          component: () => import( /* webpackChunkName: "paymentHistory" */ './view/private/paymentHistory/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getPaymnetHistories').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            document.title = 'Oddvega - Payment History'
            next();
          }
        },
        // {
        //   path: '/contest/old/',
        //   name: 'contest',
        //   component: () => import( /* webpackChunkName: "paymentHistory" */ './view/quiz-contest-dashboard/index.vue'),
        //   beforeEnter: (to, from, next) => {
        //     store.dispatch('getQuizContestListFun').then((res) => {
        //       $('.httploader').hide()
        //     }).catch((err) => {})
        //     document.title = 'Oddvega - Contest'
        //     next();
        //   }
        // },
        {
          path: '/contest/',
          name: 'contest',
          component: () => import( /* webpackChunkName: "contest" */ './view/private/quiz-contest-dashboard-api/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQuizContestListFun').then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            store.dispatch('getContestPointsObtainedFun')
            store.dispatch('getContestLeaderBoardListFun')
            document.title = 'Oddvega - Contest'
            next();
          }
        },
        {
          path: '/contest/testing/',
          name: 'contestTesting',
          component: () => import( /* webpackChunkName: "contest" */ './view/private/quiz-contest-dashboard-api/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getQuizContestForTestingListFun', {id:1}).then((res) => {
              $('.httploader').hide()
            }).catch((err) => {})
            store.dispatch('getContestPointsObtainedFun')
            store.dispatch('getContestLeaderBoardListFun')
            document.title = 'Oddvega - Contest Testing'
            next();
          }
        },
        {
          path: '/contest/quiz/:quizId',
          name: 'contestQuiz',
          component: () => import( /* webpackChunkName: "contestQuiz" */ './view/private/contestQuiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Contest Quiz'
            next();
          }
        },
        {
          path: '/contest/testing/quiz/:quizId',
          name: 'contestTestingQuiz',
          component: () => import( /* webpackChunkName: "contestTestingQuiz" */ './view/private/contestQuiz/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Contest Quiz'
            next();
          }
        },
        {
          path: '/notifications/',
          name: 'globalNotifcations',
          component: () => import( /* webpackChunkName: "globalNotifcations" */ './view/private/global-notification-page/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Notifications'
            next();
          }
        },
        {
          path: '/workspace/',
          name: 'workspace',
          component: () => import( /* webpackChunkName: "workspace" */ './view/private/workspace/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Workspace',
            next();
           }
        },
        {
          path: '/users/',
          name: 'AllUsersList',
          component: () => import( /* webpackChunkName: "AllUsersList" */ './view/private/all-users-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberUserListAction')
            document.title = 'Oddvega - All Users',
            next();
           }
        },
        {
          path: '/users/request/list/',
          name: 'userReqListPage',
          component: () => import( /* webpackChunkName: "userReqListPage" */ './view/private/user-req-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getConnectionReqListAction')
            document.title = 'Oddvega - Users Request',
            next();
           }
        },
        {
          path: '/research/papers/',
          name: 'researchPapers',
          component: () => import( /* webpackChunkName: "researchPapers" */ './view/private/research-papers/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Oddvega - Research Papers'
            next();
          },
          children: [
            {
              path: '/research/papers/',
              name: 'researchPapersList',
              component: () => import( /* webpackChunkName: "researchPapersList" */ './view/private/research-papers/rp-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun')
                document.title = 'Oddvega - Research Papers',
                next();
               }
            },
            {
              path: '/research/papers/favourites/',
              name: 'researchPapersFavouritesList',
              component: () => import( /* webpackChunkName: "researchPapersFavouritesList" */ './view/private/research-papers/favourite-papers-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getFavouritePaperListFun')
                document.title = 'Oddvega - Research Favourites Papers',
                next();
               }
            },
            {
              path: '/research/papers/shared/',
              name: 'researchPapersSharedList',
              component: () => import( /* webpackChunkName: "researchPapersSharedList" */ './view/private/research-papers/shared-papers-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getSharedPaperListFun')
                document.title = 'Oddvega - Research Shared Papers',
                next();
               }
            },
            {
              path: '/research/papers/group/',
              name: 'researchPapersGroupList',
              component: () => import( /* webpackChunkName: "researchPapersGroupList" */ './view/private/research-papers/research-group-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun')
                store.dispatch('getResearchGroupListFun')
                document.title = 'Oddvega - Research Group Papers',
                next();
               }
            },
            {
              path: '/research/papers/trash/',
              name: 'researchPapersTrashList',
              component: () => import( /* webpackChunkName: "researchPapersTrashList" */ './view/private/research-papers/trash-papers-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getTrashPaperListFun')
                store.dispatch('getTrashFolderListFun')
                document.title = 'Oddvega - Research Trash Papers',
                next();
               }
            },
          ]
        },
      ]
    },
    {
      path: '/interview/list/',
      name: 'interviewContestList',
      component: () => import( /* webpackChunkName: "interviewContestList" */ './view/public/interview/contest-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview'
        next();
      }
    },
    {
      path: '/interview/:contestId',
      name: 'interviewContestDashboard',
      component: () => import( /* webpackChunkName: "interviewContestDashboard" */ './view/public/interview/contest-info-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview'
        next();
      }
    },
  ]
})

// Routes use for without login. these are the name of routes not path
const openRoutes = ['home', 'login', 'signup', 'testimonials', 'courseCategory', 'coursedescription',  'userVerified', 'passwordReset', 'forgotPassword', 'media', 'mediaDetails', 'PrivacyPolicy', 'termsOfCondition', 'ContactUs', 'AboutUs', 'interviewContestList', 'interviewContestDashboard', 'underMaintenance', 'userAgreement', 'workspace', 'allCategoriesPage', 'publicCourseDetails']

const BaseUrl = process.env.VUE_APP_URL;
router.beforeEach((to, from, next) => {
  $(window).scrollTop(0);
  if (openRoutes.includes(to.name)) {
    document.getElementsByTagName('meta')["robots"].content = "follow index";
    next()
  } else if (store.getters.isAuthenticated && localStorage.getItem('token') != '' && localStorage.getItem('token') != null) {
    document.getElementsByTagName('meta')["robots"].content = "nofollow noindex";
    next()
  } else {
    let redirectTo = to.path;
    redirectTo = '?redirect=' + redirectTo;
    next('/login' + redirectTo)
  }
  const canocialUrl = `${BaseUrl}`+ to.path;
  document.querySelector("link[rel='canonical']").setAttribute("href", canocialUrl);
})
/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
  if (to.name) {
    if (openRoutes.includes(to.name)) {
      $('.app-loader.global').show()
    }
    next()
  }
})
/** Hide preloader after each routes */
router.afterEach((to, from) => {
  if (openRoutes.includes(to.name)) {
    $('.app-loader.global').hide()
  }
})
export default router;